import { handleActions } from "redux-actions"
import produce from "immer"
import { REQUEST_ORDER, RECEIVE_ORDER, CLEAR_ORDER } from "./constants"

const initialState = {
  isLoading: false,
  order: undefined
}
const handleOrderRequest = produce(draft => {
  draft.order = undefined
  draft.isLoading = true
})

const handleReceiveOrder = produce((draft, { payload: { result, error } }) => {
  if (error) {
    draft.error = error
  } else {
    draft.order = parseOrder(result)
  }
  draft.isLoading = false
})

const handleClearOrder = produce(draft => {
  draft.order = undefined
})

export default handleActions(
  {
    [REQUEST_ORDER]: handleOrderRequest,
    [RECEIVE_ORDER]: handleReceiveOrder,
    [CLEAR_ORDER]: handleClearOrder
  },
  initialState
)

export const parseOrder = value => {
  if (!value) return undefined

  return {
    ...value,
    order: {
      ...value.order,
      receiver: {
        name1: value.order.receiverName1,
        name2: value.order.receiverName2,
        name3: value.order.receiverName3,
        street: value.order.receiverStreet,
        streetNumber: value.order.receiverStreetNumber,
        streetNumberAddition: value.order.receiverStreetNumberAddition,
        city: value.order.receiverCity,
        zip: value.order.receiverZip,
        country: value.order.receiverCountry
      },
      sender: {
        name1: value.order.senderName1,
        name2: value.order.senderName2,
        name3: value.order.senderName3,
        street: value.order.senderStreet,
        streetNumber: value.order.senderStreetNumber,
        streetNumberAddition: value.order.senderStreetNumberAddition,
        city: value.order.senderCity,
        zip: value.order.senderZip,
        country: value.order.senderCountry
      },
      invoice: {
        name1: value.order.customerName1,
        name2: value.order.customerName2,
        name3: value.order.customerName3,
        street: value.order.customerStreet,
        streetNumber: value.order.customerStreetNumber,
        streetNumberAddition: value.order.customerStreetNumberAddition,
        city: value.order.customerCity,
        zip: value.order.customerZip,
        country: value.order.customerCountry
      },
      neutral: {
        name1: value.order.neutralSenderName1,
        name2: value.order.neutralSenderame2,
        name3: value.order.neutralSenderame3,
        street: value.order.neutralSenderStreet,
        streetNumber: value.order.neutralSenderStreetNumber,
        streetNumberAddition: value.order.neutralSenderStreetNumberAddition,
        city: value.order.neutralSenderity,
        zip: value.order.neutralSenderZip,
        country: value.order.neutralSenderCountry
      }
    }
  }
}
